module.exports = __webpack_public_path__ + "img/footer-m.2f80135b.png";